<template>
    <modal-component v-if="modalComponentShown" :onClose="onClose" :closeOnEsc="false" 
		:classes="'modal-big popup-small expired-gift-modal'">
		<div class="header-sales expired-gift">
		</div>
		<div class="text-sales expired-gift-text"> Et produkt er blevet fjernet fra din kurv, da tidsfristen er udløbet</div>
	</modal-component>
</template>

<script>
	import ModalComponent from "../../../../UtilityComponents/ModalComponent.vue";


	export default {
		name: "ExpiredGiftDialog-gt2",
		props: ["modalComponentShown", "onClose"],
		components: {
			ModalComponent
		}
	};

</script>

<style scoped lang="scss">

</style>
